// :cow: Cosmose CONFIDENTIAL :iso:
import { CurrencyType } from '@med/app/home/campaign/model/currency-type';

export interface ProfileDto {
  user_name: string;
  scope: string[];
  ati: string;
  restrictions: string[];
  language: string;
  business_client_id: number;
  exp: number;
  authorities: string[];
  jti: string;
  client_id: string;
  currency_code: CurrencyType;
  isAccountManager: boolean;
  externalPartner: ExternalPartner;
  two_factor_authentication_enabled: boolean;
}

export enum ExternalPartner {
  SPS = 'SPS',
  NONE = 'NONE'
}
